jQuery(document).ready(function($){
    jQuery(function($){
        // Forcer le rafraîchissement des fragments WooCommerce à chaque chargement de page
        $(document.body).trigger('wc_fragment_refresh');
    });
});

document.addEventListener('DOMContentLoaded', function() {
    var customEmailInput = document.getElementById('site-footer__newsletter__email');
    var customEmailGo = document.getElementById('site-footer__newsletter__go');

    if (!customEmailInput) return;
    
    var activeCampaignForm = document.querySelector('.site-footer__newsletter__form form');

    if (customEmailInput && activeCampaignForm) {
        customEmailInput.addEventListener('input', function() {
            var activeCampaignEmailInput = activeCampaignForm.querySelector('input[id="email"]');
            if (activeCampaignEmailInput) {
                activeCampaignEmailInput.value = customEmailInput.value;
            }
        });
    }
    
    function activatePopin() {
        var myfPopin = document.querySelector('.site-footer__newsletter__form.__MyfPopin');
        if (myfPopin) {
            myfPopin.classList.add('MyfPopin--active');
        }
    }

    customEmailInput.addEventListener('keydown', function(event) {
        if (event.key === 'Enter') {
            activatePopin();
        }
    });

    if (customEmailGo) {
        customEmailGo.addEventListener('click', function() {
            setTimeout(activatePopin, 200);
        });
    }

    // Afficher la popin si le paramètre "newsletter" est présent dans l'URL
    if (
        new URLSearchParams(window.location.search).has('newsletter-boljoy') ||
        window.location.hash === '#newsletter-boljoy'
    ) {
        setTimeout(activatePopin, 200);
    }

    // Fermer la popin avec la touche Échap si elle est active
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
            var myfPopin = document.querySelector('.site-footer__newsletter__form.__MyfPopin');
            if (myfPopin && myfPopin.classList.contains('MyfPopin--active')) {
                myfPopin.classList.remove('MyfPopin--active');
            }
        }
    });

    var newsletterDiv = document.querySelector('.page-newsletter');
    if (newsletterDiv) {
        newsletterDiv.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    }


    //Animation label
    // Sélectionner tous les inputs et textareas
    let fields = document.querySelectorAll("input, textarea");

    
    // Ajouter les événements `input` et `change` à chaque champ
    fields.forEach((field) => {
        let label = field.labels ? field.labels[0] : null;

        // Fonction pour mettre à jour la classe du label
        const updateLabelClass = () => {
            if (label) {
            label.classList.toggle('has-value', !!field.value);
            }
        };

        // Événements `input` et `change` pour mettre à jour la classe du label
        field.addEventListener("input", updateLabelClass);
        field.addEventListener("change", updateLabelClass);
        
        // Initialiser la classe du label au chargement
        updateLabelClass();
    });

    //Animation label password field
    // Observer for dynamically added password inputs
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length) {
                passwordContents = document.querySelectorAll(".password-input");
                passwordContents.forEach((passwordContent) => {
                    let passwordInput = passwordContent.querySelector('input[type="password"]');                    
                    let closestLabel = passwordContent.nextElementSibling;

                    if (closestLabel && closestLabel.tagName.toLowerCase() === 'label') {
                        closestLabel.classList.add('animate-field');

                        passwordInput.addEventListener('focus', () => {
                            closestLabel.classList.add('animate-field--active');
                        });

                        passwordInput.addEventListener('blur', () => {
                            closestLabel.classList.remove('animate-field--active');
                        });
                    }
                });
            }
        });
    });

    // Start observing the document for added nodes
    observer.observe(document.body, { childList: true, subtree: true });

    // Observer for dynamically added lost password inputs
    var lostPasswordLink = document.querySelector('.woocommerce-LostPassword a');
    var lostPasswordForm = document.getElementById('lost-password-form');
    var loginForm = document.querySelector('.woocommerce-form-login');

    if (lostPasswordLink && lostPasswordForm && loginForm) {
        lostPasswordLink.addEventListener('click', function(event) {
            event.preventDefault();
            loginForm.style.display = 'none';
            lostPasswordForm.classList.add('woocommerce-lost-password--active');
        });

        document.addEventListener('click', function(event) {
            if (!lostPasswordForm.contains(event.target) && !lostPasswordLink.contains(event.target)) {
            lostPasswordForm.classList.remove('woocommerce-lost-password--active');
            lostPasswordForm.addEventListener('transitionend', function() {
                loginForm.style.display = 'block';
            }, { once: true });
            }
        });
    }


});